import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Grid, Typography, Box, Button, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import DoctorCard from "../DoctorCard";
import API from "../../helpers/apiHelpers";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {clearInfo, getAppointmentUploadURL} from "../../redux/scheduleAppointment/scheduling.actions";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

declare global {
	interface Window {
        fbq:any;
		gtag: any;
    }
}

const useStyle = makeStyles(() => ({
    titleWrapper: {
        marginBottom: "20px"
    },
    hrefWrapper: {
        textDecoration: "none"
    },
    buttonWrapper: {
        marginBottom: "0.1rem",
    }
}));

const VetConfirmation = () => {
    const classes = useStyle();
    const history = useHistory<{ appointmentId: number, total: string, type: string }>();
    const { location: { state: { appointmentId, total, type } } } = history;
    const environment = window.location.pathname.includes("app.helloralphie") ? "PROD" : "STAGING";
    const schedulingReducer = useSelector((state: RootState) => state?.scheduleAppointment);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const { immediate, uploadPhotos, uploadVideo } = schedulingReducer;
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user);

    useEffect(() => {
        let purchaseSource = isWhiteLabel ? "whitelabel" : "webapp";
        sessionStorage.setItem("loaded", "true");
        //FB Tracking
        window.fbq("track", "Purchase", {value: parseFloat(total).toFixed(2), currency: "USD", userId: user.userId ,type: type,amount: parseFloat(total).toFixed(2),environemnt: environment,device: "web/browser"});
        return () => dispatch(clearInfo());
    }, []);

    useEffect(() => {
        Object.keys(uploadPhotos).forEach(key => {
            dispatch(getAppointmentUploadURL(appointmentId))
                .then(res => {
                    const { uploadUrl } = res;
                    const photo = uploadPhotos[key];
                    if (uploadUrl && photo) {
                        fetch(photo)
                            .then(res => res.blob())
                            .then(res => API.uploadToAWS(uploadUrl, res))
                            .catch(console.log);
                    }
                })
                .catch(console.log);
        });
        if(uploadVideo){
            dispatch(getAppointmentUploadURL(appointmentId, true))
                .then(res => {
                    const { uploadUrl } = res;
                    if (uploadUrl) {
                        fetch(uploadVideo)
                            .then(res => res.blob())
                            .then(res => API.uploadVideoToAWS(uploadUrl, res))
                            .catch(console.log);
                    }
                })
                .catch(console.log);
        }
    }, [appointmentId]);

    return (
        <Container maxWidth="md">
            <Box marginTop="90px" marginBottom="50px">
                <Grid container>
                    <Grid item justify="center" alignItems="center">
                        <Button onClick={() => history.push("/appointments")}>
                            <Typography variant="button" style={{display: "flex", alignItems: "center", padding: 0}}><ArrowBackIcon fontSize="small" style={{paddingRight: 5}}/>Back to Dashboard</Typography>
                        </Button>
                    </Grid>
                </Grid>
                <Grid container direction="column">
                    <DoctorCard appointmentId={appointmentId} />
                </Grid>
            </Box>
            {	!sessionStorage.getItem("loaded") &&
				<>
				    <img
				        src={`https://www.shareasale.com/sale.cfm?tracking=${appointmentId}&amount=${parseFloat(total).toFixed(2)}&merchantID=105718&transtype=sale`}
				        width="1" height="1"/>
				    <script src="https://www.dwin1.com/19038.js" type="text/javascript" defer={true}/>
				</>
            }
        </Container>
    );
};

export default VetConfirmation;
